import * as HomeOwnersActionType from './constants';

const defaultParams = {
  searchKey: '',
  skip: 0,
  take: 10,
  sort: { field: 'fullName', order: 'ascending' },
  status: 'all',
  totalRecord: 0,
  totalPage: 1
};

const ManageCurrentAssignedLots = {
  items: [],
  params: {
    searchKey: '',
    skip: 1,
    take: 50,
    sort: { field: 'projectName', order: 'ascending' },
    totalRecord: 0,
    totalPage: 0
  }
};

const ManageFormerAssignedLots = {
  items: [],
  params: {
    searchKey: '',
    skip: 1,
    take: 50,
    sort: { field: 'projectName', order: 'ascending' },
    totalRecord: 0,
    totalPage: 0
  }
};

const ManageTenancyAssignedLots = {
  items: [],
  params: {
    searchKey: '',
    skip: 1,
    take: 50,
    sort: { field: 'projectName', order: 'ascending' },
    totalRecord: 0,
    totalPage: 0
  }
};

const HomeOwnerState = {
  ManageHomeOwner: {
    items: [],
    params: defaultParams
  },
  ErrorMsg: {},
  SelectListHomeowner: [],
  ManageCurrentAssignedLots: ManageCurrentAssignedLots,
  ManageFormerAssignedLots: ManageFormerAssignedLots,
  ManageTenancyAssignedLots: ManageTenancyAssignedLots,
  HomeownerProfile: null
};

export default function BuilderStore(state = HomeOwnerState, action) {
  switch (action.type) {
    case HomeOwnersActionType.GET_HOME_OWNER_LIST_SUCCESS :
      return processSearchSuccess(state, action);
    case HomeOwnersActionType.EDIT_HOME_OWNER_INFO_FAIL:
      return {
        ...state,
        ErrorMsg: {
          editHomeOwnerInfo: action.data
        }
      };
    case HomeOwnersActionType.GET_SELECT_LIST_HOMEOWNER_SUCCESS:
      return {
        ...state,
        SelectListHomeowner: action.data
      };
    case HomeOwnersActionType.SEARCH_CURRENT_ASSIGNED_LOT_SUCCESS:
      return processSearchCurrentAssignedLotSuccess(state, action);
    case HomeOwnersActionType.SEARCH_FORMER_ASSIGNED_LOT_SUCCESS:
      return processSearchFormerAssignedLotSuccess(state, action);
    case HomeOwnersActionType.SEARCH_TENANCY_ASSIGNED_LOT_SUCCESS:
      return processSearchTenancyAssignedLotSuccess(state, action);
      // case HomeOwnersActionType.SEARCH_HOME_OWNER_SUCCESS:
      //   return processSearchTenancyAssignedLotSuccess(state, action);
    case HomeOwnersActionType.RESET_HOMEOWNER_LIST:
      return {
        ...state,
        ManageHomeOwner: {
          items: [],
          params: defaultParams
        }
      };
    case HomeOwnersActionType.GET_HOMEOWNER_PROFILE_SUCCESS:
      return {
        ...state,
        HomeownerProfile: action.data
      };
    default:
      return state;
  }
}

const processSearchSuccess = (state, action) => {
  var result = action.data;
  var manageHomeOwner = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip,
      take: result.params.take,
      status: result.params.status,
      name: result.params.name,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };
  return {
    ...state,
    ManageHomeOwner: manageHomeOwner,
    ErrorMsg: {}
  };
};

const processSearchCurrentAssignedLotSuccess = (state, action) => {
  var result = action.data;
  var mCurrentLots = {
    items: result.data.items,
    params: {
      ...state.ManageCurrentAssignedLots.params,
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage
    }
  };
  return {
    ...state,
    ManageCurrentAssignedLots: mCurrentLots
  };
};

const processSearchFormerAssignedLotSuccess = (state, action) => {
  var result = action.data;
  var mFormerLot = {
    items: result.data.items,
    params: {
      ...state.ManageFormerAssignedLots.params,
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage
    }
  };
  return {
    ...state,
    ManageFormerAssignedLots: mFormerLot
  };
};

const processSearchTenancyAssignedLotSuccess = (state, action) => {
  var result = action.data;
  console.log(result,'result')
  var mTenancyLot = {
    items: result.data.items,
    params: {
      ...state.ManageTenancyAssignedLots.params,
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage
    }
  };
  return {
    ...state,
    ManageTenancyAssignedLots: mTenancyLot
  };
};




// WEBPACK FOOTER //
// ./src/HomeOwners/reducers.js